import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';

import FullProduct from '../../../models/product/FullProduct';
import FullProductMatrix from '../../../models/product/FullProductMatrix';
import { modelOf } from '../../../prop-types';
import CartStore from '../../../store/CartStore';
import ProductCollectionMatrixRow from '../ProductCollectionMatrixRow';

const ProductCollectionMatrixTableBodyComponent = ({
  product,
  productMatrix,
  ifProductRowImages,
  tooltipStates,
  onImageClick,
  onQuantityNotify,
  cartStore,
}) => {
  return (
    <tbody>
      {productMatrix.getDisplayRows().map((displayRow) => (
        <ProductCollectionMatrixRow
          key={displayRow.element.id}
          displayRow={displayRow}
          product={product}
          productMatrix={productMatrix}
          ifProductRowImages={ifProductRowImages}
          tooltipStates={tooltipStates}
          onImageClick={onImageClick}
          onQuantityNotify={onQuantityNotify}
          cartStore={cartStore}
          isLeftAligned={productMatrix.isLeftAligned}
        />
      ))}
    </tbody>
  );
};

ProductCollectionMatrixTableBodyComponent.propTypes = {
  product: modelOf(FullProduct).isRequired,
  productMatrix: modelOf(FullProductMatrix).isRequired,
  ifProductRowImages: PropTypes.func,
  tooltipStates: PropTypes.object.isRequired,
  onImageClick: PropTypes.func.isRequired,
  onQuantityNotify: PropTypes.func.isRequired,
  cartStore: modelOf(CartStore).isRequired,
};

export default observer(ProductCollectionMatrixTableBodyComponent);
